import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorksSection() {
  const steps = [{
    number: '1',
    title: 'Identifica',
    desc: 'Encuentra el origen de tu compresión con nuestro test rápido.'
  }, {
    number: '2',
    title: 'Libera',
    desc: 'Aplica el protocolo de 8 minutos para abrir espacio en tus vértebras.'
  }, {
    number: '3',
    title: 'Protege',
    desc: 'Sigue las pautas de movimiento diario para que el dolor no regrese nunca.'
  }];
  return <section className="py-16 md:py-24 bg-cream-100" data-id="element-108">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-109">
        <FadeIn data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-16 text-center" data-id="element-111">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-112">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-teal-200 z-0" data-id="element-113"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} direction="up" className="relative z-10" data-id="element-114">
              <div className="flex flex-col items-center text-center" data-id="element-115">
                <div className="w-24 h-24 rounded-full bg-white shadow-lg border-4 border-teal-100 flex items-center justify-center mb-6" data-id="element-116">
                  <span className="text-4xl font-serif font-bold text-teal-600" data-id="element-117">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-teal-900 mb-4" data-id="element-118">
                  {step.title}
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-119">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}